document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) {
    const header = toggle.closest('.site-header');
    const open = header.classList.toggle('menu-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  const details = event.target.closest('[data-accordion] summary');
  if (details) {
    document.querySelectorAll('[data-accordion][open]').forEach((item) => {
      if (item !== details.parentElement) item.removeAttribute('open');
    });
  }
});

document.addEventListener('change', (event) => {
  const selector = event.target.closest('[data-variant-select]');
  if (!selector) return;
  const option = selector.options[selector.selectedIndex];
  const form = selector.closest('form');
  const input = form && form.querySelector('[name="id"]');
  if (input) input.value = option.value;
  const price = document.querySelector('[data-product-price]');
  if (price && option.dataset.price) price.textContent = option.dataset.price;
});

document.addEventListener('shopify:section:load', () => document.documentElement.classList.remove('no-js'));
